import React from 'react';
import { ActiveLanguagesForm } from './ActiveLanguagesForm';
import { ActiveLanguagesTable } from './ActiveLanguagesTable';
import { LocalizationModel } from './LocalizationModel';

export const ActiveLanguagesTab = ({
  projectId,
  localization,
  maximumActiveLanguages,
  saveLocalizationConfig,
  deleteLocalizationConfig,
  changeDefaultLanguage,
  toggleActiveLang,
  setToggleActiveLang,
  isReadOnly,
}) => {
  return (
    <LocalizationModel
      title={'Manage Languages'}
      toggle={toggleActiveLang}
      setToggle={setToggleActiveLang}
    >
      <ActiveLanguagesForm
        projectId={projectId}
        localization={localization}
        saveLocalizationConfig={saveLocalizationConfig}
        maximumActiveLanguages={maximumActiveLanguages}
        changeDefaultLanguage={changeDefaultLanguage}
        isReadOnly={isReadOnly}
      />
      <ActiveLanguagesTable
        projectId={projectId}
        localization={localization}
        deleteLocalizationConfig={deleteLocalizationConfig}
        changeDefaultLanguage={changeDefaultLanguage}
        isReadOnly={isReadOnly}
      />
    </LocalizationModel>
  );
};
